export const SET_IS_CLIENT = 'SET_IS_CLIENT';
export const SET_IS_ADMIN = 'SET_IS_ADMIN';
export const SET_APP_MAINTENANCE = 'SET_APP_MAINTENANCE';
